'use client';
import React, { memo } from 'react';
import useApplyLogging from '../../hooks/useApplyLogging.mjs';

function IcQMark(customProps) {
  const {
    fill,
    ...props
  } = customProps;
  useApplyLogging('ICON_IcQMark');
  return /*#__PURE__*/React.createElement("svg", {
    width: "100%",
    height: "100%",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...props
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.0001 2.9001C6.97431 2.9001 2.9001 6.97431 2.9001 12.0001C2.9001 17.0259 6.97431 21.1001 12.0001 21.1001C17.0259 21.1001 21.1001 17.0259 21.1001 12.0001C21.1001 6.97431 17.0259 2.9001 12.0001 2.9001ZM1.1001 12.0001C1.1001 5.98019 5.98019 1.1001 12.0001 1.1001C18.02 1.1001 22.9001 5.98019 22.9001 12.0001C22.9001 18.02 18.02 22.9001 12.0001 22.9001C5.98019 22.9001 1.1001 18.02 1.1001 12.0001Z",
    fill: fill || '#767678'
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.5 9.24C8.6 7.24 9.99 6 12.13 6C14.17 6 15.66 7.27 15.66 9.03C15.66 10.24 15.08 11.21 13.92 11.91C12.95 12.49 12.65 12.91 12.65 13.74V14.36H11.03V13.52C11.02 12.44 11.52 11.67 12.7 10.97C13.63 10.4 13.96 9.91 13.96 9.1C13.96 8.12 13.24 7.46 12.08 7.46C10.92 7.46 10.17 8.13 10.08 9.25V9.34H8.5V9.24ZM10.75 16.8899C10.75 16.1999 11.25 15.6899 11.95 15.6899H11.96C12.66 15.6899 13.16 16.2099 13.16 16.8899C13.16 17.5699 12.67 18.0699 12 18.0899H11.96H11.91C11.61 18.0899 11.31 17.9699 11.09 17.7499C10.86 17.5199 10.74 17.2099 10.75 16.8899Z",
    fill: fill || '#767678'
  }));
}
var IcQMark$1 = /*#__PURE__*/memo(IcQMark);

export { IcQMark$1 as default };
